import config from '../../package.json';
import navigationTypes from '../actions/_navigationTypes';
import { eventLogger } from '../utils/hooks/useNewRelic';
const { detect } = require('detect-browser');
const browser = detect();

const eventLog = eventLogger();

export async function postMetric(data) {
  let payload = {
    metricType: data.metricType,
    eventType: data.metricName,
    timestamp: new Date().toISOString(),
    component: 'Popsicle',
    href: window.location.href,
    browserName: browser.name,
    browserVersion: browser.version,
    platform: window.navigator.platform || 'Unknown',
    version: config.version
  };

  // Used to pass extra data in an object
  if (data.customData) {
    payload = Object.assign(payload, data.customData);
  }

  await eventLog.sendEvent(payload);
}

export async function postUserTrade(data) {
  switch (data.navigationType) {
    case navigationTypes.MB_CASH_BUY_CLICK:
    case navigationTypes.SD_CASH_BUY_CLICK:
    case navigationTypes.MP_CASH_BUY_CLICK:
    case navigationTypes.MP_MATRIX_CASH_BUY_CLICK:
    case navigationTypes.SD_MATRIX_CASH_BUY_CLICK:
    case navigationTypes.SS_CASH_BUY_CLICK:
      data.metricName = 'CashBuy';
      data.urlType = 'buy';
      break;
    case navigationTypes.MB_CASH_SELL_CLICK:
    case navigationTypes.SD_CASH_SELL_CLICK:
    case navigationTypes.MP_CASH_SELL_CLICK:
    case navigationTypes.MP_MATRIX_CASH_SELL_CLICK:
    case navigationTypes.SD_MATRIX_CASH_SELL_CLICK:
      data.metricName = 'CashSell';
      data.urlType = 'sell';
      break;
    case navigationTypes.MB_MARGIN_ORDER_CLICK:
    case navigationTypes.SD_MARGIN_ORDER_CLICK:
    case navigationTypes.MP_MARGIN_ORDER_CLICK:
      data.metricName = 'MarginBuy';
      data.urlType = 'margin';
      break;
    case navigationTypes.MB_MARGIN_SELL_CLICK:
    case navigationTypes.SD_MARGIN_SELL_CLICK:
    case navigationTypes.MP_MARGIN_SELL_CLICK:
      data.metricName = 'MarginSell';
      data.urlType = 'marginRefund';
      break;
    case navigationTypes.SD_SMALL_LOT_ORDER_CLICK:
    case navigationTypes.MP_SMALL_LOT_ORDER_CLICK:
      data.metricName = 'SmallLotOrder';
      data.urlType = 'buy';
      break;
    case navigationTypes.SD_ODD_LOT_ORDER_CLICK:
    case navigationTypes.MP_ODD_LOT_ORDER_CLICK:
      data.metricName = 'OddLotOrder';
      data.urlType = 'buy';
      break;
  }

  let payload = {
    eventType: 'UserTrade',
    component: 'Popsicle',
    orderType: data.metricName,
    side: data.urlType,
    symbol: data.symbol,
    urlType: data.urlType,
    userId: data.encryptedId,
    urlHost: window.location.hostname,
    urlPath: window.location.pathname,
    browserName: browser.name,
    browserVersion: browser.version,
    platform: window.navigator.platform || 'Unknown'
  };

  await eventLog.sendEvent(payload);
}
